export const getSupabaseRange = (page = 1, limit = 10) => {
  return {
    rangeStart: Math.max(0, page - 1) * limit,
    rangeEnd: page * limit - 1
  }
}
